import React, { useEffect, useState } from "react";
import "./Profile.scss";
import { MdOutlineContentCopy } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { otherDataAC } from "../../../../store/action-creators";
import {  getAddress, getAltAddress, getBlockchainType } from "../../../../utils/services/auth";
import {
  bytesToString,
  clipText,
  copyToClipboard,
} from "../../../../utils/services/other";
import { LinearProgress, linearProgressClasses, styled } from "@mui/material";


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}));

const Profile: React.FC = () => {
  const dispatch = useDispatch();
  const _balanceStore = useSelector((store: any) => store?.balance);
  const _otherData = bindActionCreators(otherDataAC, dispatch);
  return (
    <div className="Profile">
      <div className="Profile__title">
        <p>My Profile</p>
      </div>

      <div className="Profile__InfoContainer">
        <div className="AddressContainer">
          <div className="label">Public Address</div>
          <div className="addressBox">
            <p className="address">
              {getAltAddress()}{" "}
              <span
                className="icon"
                onClick={() => {
                  copyToClipboard(getAltAddress() || "");
                }}
              >
                <MdOutlineContentCopy />
              </span>
            </p>
          </div>
        </div>
        {
          getBlockchainType() === 'Coreum' &&     <div className="AddressContainer">
          <div className="label">Sharable Address</div>
          <div className="addressBox">
            <p className="address">
              { clipText(getAddress() || '',20,10)}{" "}
              <span
                className="icon"
                onClick={() => {
                  copyToClipboard(getAddress() || '');
                }}
              >
                <MdOutlineContentCopy />
              </span>
            </p>
          </div>
        </div>
        }
    

        <div className="AddressContainer">
          <div className="label">Email Address</div>
          <div className="addressBox">
            {_balanceStore?.email ? (
              <p className="address">
                {_balanceStore?.email}
                &nbsp;
                <span
                  className="icon"
                  onClick={() => {
                    copyToClipboard(_balanceStore?.email);
                  }}
                >
                  <MdOutlineContentCopy />
                </span>
              </p>
            ) : (
              <button
                className="fillBtn__blue"
                style={{ margin: 0, marginTop: "5px" }}
                onClick={() => {
                  _otherData.setOtherData({ isVerifyEmailDialog: true });
                }}
              >
                Add Email
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="Profile__SpaceContainer">
        <div className="label">Space Used</div>
        {_balanceStore && (
          <div className="spaceBox">
                  <BorderLinearProgress variant="determinate" value={(_balanceStore["dataUsed"] / _balanceStore["dataLimit"]) * 100} />

            {
              <p>
                {bytesToString(_balanceStore["dataUsed"])} /{" "}
                {bytesToString(_balanceStore["dataLimit"])}
              </p>
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
